<app-template [hasContentFrame]="true" [titel]="'Newsletter'">
  <p>Dies ist eine Liste an Email-Adressen von Nutzern, welche dem Newsletter-Versand zugestimmt haben.</p>
  <div class="email-list"
    *skeleton="!newsletterUsers; height: '300px'; width: '100%'; type: 'text'">
    <textarea #emailTextArea
      class="email-textarea"
      readonly
      [value]="getEmailList(newsletterUsers)"></textarea>

    <div class="actions">
      <button class="eForms-button"
        [cdkCopyToClipboard]="getEmailList(newsletterUsers)"
        (click)="selectAllText(emailTextArea)">
        <mat-icon>content_copy</mat-icon>
        <span>In die Zwischenablage kopieren</span>
      </button>
    </div>
  </div>

  <hr class="section-divider">

  <h2>Nutzer aus Newsletter abmelden</h2>
  <p>Bitte geben Sie hier eine Mailadresse zum Entfernen aus der Abonnentenliste an.</p>

  <div class="unsubscribe-section">
    <div class="input-button-container">
      <div class="input-container">
        <input
          [formControl]="emailFormControl"
          class="form-textarea"
          name="emailToRemove"
          placeholder="beispiel@mailadresse.de"
          autocomplete="off"
          data-1p-ignore
          data-lpignore="true"
          data-protonpass-ignore="true"
          data-bwignore="true"
          />
          <!-- /\ To disable password manager on field -->
        <div *ngIf="emailFormControl.dirty && emailFormControl.hasError('required')" class="validation-error">
          Bitte geben Sie einen Wert ein.
        </div>
        <div *ngIf="emailFormControl.dirty && emailFormControl.hasError('pattern')" class="validation-error">
          Bitte geben Sie eine valide E-Mail-Adresse ein.
        </div>
      </div>

      <div class="button-container">
        <button mat-button class="eForms-button eForms-button--primary"
                [disabled]="emailFormControl.invalid || !emailFormControl.value"
                (click)="removeFromNewsletter()">
          <span>Aus Abonnentenliste entfernen</span>
        </button>
      </div>
    </div>

    <div class="message-container">
      <div *ngIf="errorMessage" class="error-message">
        <p>{{ errorMessage }}</p>
      </div>
      <div *ngIf="successMessage" class="success-message">
        <p>{{ successMessage }}</p>
      </div>
    </div>
  </div>
</app-template>
